<div class="audit-container">
  <h2>Audit - Analisi Accessi Pratiche</h2>

  <!-- Filtri -->
  <div class="filters-section">
    <form [formGroup]="filterForm" (ngSubmit)="applyFilters()">
      <div class="row">
        <div class="col-md-3">
          <label for="dataCreazioneDa">Data creazione da:</label>
          <input type="date" id="dataCreazioneDa" formControlName="dataCreazioneDa" class="form-control">
        </div>
        <div class="col-md-3">
          <label for="dataCreazioneA">Data creazione a:</label>
          <input type="date" id="dataCreazioneA" formControlName="dataCreazioneA" class="form-control">
        </div>
        <div class="col-md-3">
          <label for="agenzia">Agenzia:</label>
          <input type="text" id="agenzia" formControlName="agenzia" class="form-control"
                 list="agenzieList" placeholder="Seleziona agenzia...">
          <datalist id="agenzieList">
            <option *ngFor="let agenzia of agenzieList" [value]="agenzia">
          </datalist>
        </div>
        <div class="col-md-3">
          <label for="numeroPratica">Numero pratica:</label>
          <input type="text" id="numeroPratica" formControlName="numeroPratica" class="form-control"
                 placeholder="Inserisci numero pratica...">
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-md-3">
          <label for="minutiDa">Minuti consultazione da:</label>
          <input type="number" id="minutiDa" formControlName="minutiDa" class="form-control"
                 placeholder="0" min="0" step="0.01">
        </div>
        <div class="col-md-3">
          <label for="minutiA">Minuti consultazione a:</label>
          <input type="number" id="minutiA" formControlName="minutiA" class="form-control"
                 placeholder="999" min="0" step="0.01">
        </div>
        <div class="col-md-6 d-flex align-items-end">
          <button type="submit" class="btn btn-primary me-2" [disabled]="loading">
            <i class="fas fa-search"></i> Applica Filtri
          </button>
          <button type="button" class="btn btn-secondary" (click)="resetFilters()" [disabled]="loading">
            <i class="fas fa-times"></i> Reset
          </button>
        </div>
      </div>
    </form>
  </div>

  <!-- Loading -->
  <div *ngIf="loading" class="text-center my-4">
    <div class="spinner-border" role="status">
      <span class="visually-hidden" style="opacity: 0;">Caricamento...</span>
    </div>
  </div>

  <!-- Errore -->
  <div *ngIf="error" class="alert alert-danger mt-3">
    <i class="fas fa-exclamation-triangle"></i> {{ error }}
  </div>

  <!-- Risultati -->
  <div *ngIf="!loading && !error" class="results-section mt-4">
    <h3 style="display: none;">Risultati ({{ auditResults.length }} pratiche)</h3>

    <div class="table-responsive">
      <table class="table table-striped table-hover">
        <thead class="table-dark">
        <tr>
          <th>Numero Pratica</th>
          <th>Importo Totale</th>
          <th>Agenzia</th>
          <th>Cognome Intestatario</th>
          <th>Tempo Totale Accesso</th>
          <th>Numero Aperture</th>
          <th>Ultima Visita</th>
          <th>Tempo Medio Visita</th>
          <th>Azioni</th>
        </tr>
        </thead>
        <tbody>
        <ng-container *ngFor="let result of filteredAuditResults">
          <!-- Riga principale -->
          <tr>
            <td>{{ result.numeroPratica }}</td>
            <td>{{ result.importoTotale | currency:'EUR':'symbol':'1.2-2' }}</td>
            <td>{{ result.agenzia }}</td>
            <td>{{ result.cognomeIntestatario }}</td>
            <td>{{ formatDuration(result.tempoTotaleAccesso) }}</td>
            <td>{{ result.numeroTotaleAperture }}</td>
            <td>{{ result.ultimaVisita | localizedDate:'dd/MM/yyyy HH:mm' }}</td>
            <td>{{ formatDuration(result.tempoMedioVisita) }}</td>
            <td>
              <button class="btn btn-sm btn-outline-primary"
                      (click)="toggleRowExpansion(result.numeroPratica)">
                <i class="fas" [class.fa-chevron-down]="!isRowExpanded(result.numeroPratica)"
                   [class.fa-chevron-up]="isRowExpanded(result.numeroPratica)"></i>
                Dettagli
              </button>
            </td>
          </tr>

          <!-- Riga dettagli espandibile -->
          <tr *ngIf="isRowExpanded(result.numeroPratica)">
            <td colspan="9" class="bg-light">
              <div class="expanded-details">
                <h5>Dettagli Sessioni di Accesso</h5>
                <div class="table-responsive">
                  <table class="table table-sm">
                    <thead>
                    <tr>
                      <th>Data Accesso</th>
                      <th>Ora Inizio Sessione</th>
                      <th>Durata Sessione</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr *ngFor="let sessione of result.sessioniDettagliate">
                      <td>{{ sessione.dataAccesso | localizedDate:'dd/MM/yyyy' }}</td>
                      <td>{{ sessione.oraInizioSessione | localizedDate:'HH:mm:ss' }}</td>
                      <td>{{ formatDuration(sessione.durataSessione) }}</td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </td>
          </tr>
        </ng-container>
        </tbody>
      </table>
    </div>

    <!-- Messaggio se nessun risultato -->
    <div *ngIf="auditResults.length === 0" class="alert alert-info">
      <i class="fas fa-info-circle"></i> Nessuna pratica trovata con i filtri applicati.
    </div>
  </div>
</div>
